var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickGreenBigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 116,
    height: 116,
    rx: 58,
    fill: "#A6F4C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.6673 64.0067V66C87.6647 70.6722 86.1517 75.2185 83.3542 78.9606C80.5567 82.7028 76.6244 85.4404 72.1439 86.7651C67.6634 88.0899 62.8747 87.9308 58.492 86.3116C54.1093 84.6924 50.3674 81.6999 47.8244 77.7803C45.2814 73.8607 44.0735 69.2241 44.381 64.562C44.6884 59.8999 46.4946 55.462 49.5303 51.9103C52.5659 48.3586 56.6684 45.8833 61.2257 44.8536C65.7831 43.824 70.5512 44.2951 74.819 46.1967M87.6673 48.6667L66.0007 70.355L59.5007 63.855",
    stroke: "#039855",
    strokeWidth: 5.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 116,
    height: 116,
    rx: 58,
    stroke: "#ECFDF3",
    strokeWidth: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreenBigIcon);
export default __webpack_public_path__ + "static/media/tick-green-big-icon.0ac5e91ba10c04d4573acc7eb9ef555c.svg";
export { ForwardRef as ReactComponent };